import { Box, Dialog, DialogContent, IconButton, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { ReactComponent as RocketIcon } from './assets/🚀.svg'
import { ReactComponent as BoxIcon } from './assets/📦.svg'
import { ReactComponent as CloseIcon } from './assets/close-modal.svg'
const BlockingModal = observer(({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: '8px !important',
                    boxShadow: 'none !important',
                    margin: '0px',
                    maxWidth: '600px',
                    width: {
                        xs: '398px',
                        sm: '450px',
                        md: '600px'
                    },
                    backgroundColor: 'rgba(7, 38, 72, 1)',
                    position: 'relative'
                }
            }}>
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    padding: '4px',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)'
                    }
                }}>
                <CloseIcon />
            </IconButton>
            <DialogContent
                sx={{
                    padding: {
                        xs: '32px 24px',
                        sm: '32px 50px'
                    }
                }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        textAlign: 'center',
                        gap: '24px'
                    }}>
                    <Stack gap={'8px'}>
                        <Stack direction={'row'}>
                            <Typography variant="body1" fontWeight={400} sx={{ fontSize: '18px!important', color: '#ffffff', fontFamily: 'Inter', textAlign: 'left' }}>
                                We have moved to{' '}
                                <Typography
                                    variant="body1"
                                    fontWeight={400}
                                    sx={{ fontSize: '18px!important', color: 'rgba(7, 159, 244, 1)', fontFamily: 'Inter', textDecoration: 'underline', textAlign: 'left' }}
                                    component={'a'}
                                    href="https://u-feelgreat.myshopify.com/">
                                    Shopify
                                </Typography>{' '}
                                <RocketIcon sx={{ width: '18px', height: '18px', ml: '4px', verticalAlign: 'middle' }} />
                            </Typography>
                        </Stack>
                        <Typography variant="body1" fontWeight={400} sx={{ fontSize: '18px!important', color: '#ffffff', fontFamily: 'Inter', letterSpacing: '0', textAlign: 'left' }}>
                            This site is used only to manage existing subscriptions <BoxIcon sx={{ width: '18px', height: '18px', ml: '4px', verticalAlign: 'middle' }} />
                        </Typography>
                    </Stack>
                </Box>
            </DialogContent>
        </Dialog>
    )
})

export default BlockingModal
